import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_PII_INTENT_ROUTING_FEATURE_ENABLED is set to
// "true" on the server. Reads from the public /app-config endpoint so the
// flag is available pre-auth. The Chat Settings page hides the PII intent
// routing toggle and model slots when off; the backend keeps the org-level
// settings inert for the same flag.
export const usePiiIntentRoutingFeatureEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isPiiIntentRoutingFeatureEnabled ?? false;
};
